import type { ErrorContext, ErrorTracker } from './types.ts';

class ErrorTrackerSingleton {
  private provider: ErrorTracker | null = null;

  configure(provider: ErrorTracker, config: any) {
    this.provider = provider;
    this.provider.init(config);
  }

  captureException(error: Error | unknown, context?: ErrorContext) {
    if (!this.provider) {
      // eslint-disable-next-line no-console
      console.error('[ErrorTracker not configured]', error, context);
      return;
    }
    this.provider.captureException(error, context);
  }

  captureMessage(message: string, level: 'info' | 'warning' | 'error' = 'info', context?: ErrorContext) {
    if (!this.provider) {
      // eslint-disable-next-line no-console
      console.warn('[ErrorTracker not configured]', message, context);
      return;
    }
    this.provider.captureMessage(message, level, context);
  }
}

export const errorTracker = new ErrorTrackerSingleton();
